var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 17.679C26.6666 18.1767 26.4623 18.654 26.0986 19.0059C25.7349 19.3578 25.2416 19.5555 24.7273 19.5555H7.27271C6.75835 19.5555 6.26506 19.3578 5.90135 19.0059C5.53764 18.654 5.33331 18.1767 5.33331 17.679V7.35801C5.33331 6.86032 5.53764 6.38302 5.90135 6.0311C6.26506 5.67918 6.75835 5.48147 7.27271 5.48147H11.1515L13.0909 2.66666H18.9091L20.8485 5.48147H24.7273C25.2416 5.48147 25.7349 5.67918 26.0986 6.0311C26.4623 6.38302 26.6666 6.86032 26.6666 7.35801V17.679Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11.5556,
    r: 4.44444,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29C7.71573 29 1 25.8277 1 21.9144C1 20.8756 1.47327 19.8889 2.32353 19M29.6765 19C30.5267 19.8889 31 20.8756 31 21.9144C31 24.621 27.7874 26.9731 23.0653 28.1664",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3175 25.6174L21.6049 28.9773L24.9648 30.69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCamera);
export default __webpack_public_path__ + "static/media/switch-camera.55454cbd6d31e94979b4e16fff818e81.svg";
export { ForwardRef as ReactComponent };